import { requestHandler } from '../../helpers';
import { api } from '..';
import { SetupPartnerPosFlowResponse } from './interfaces';

export function setupPartnerPosFlow() {
	return requestHandler<SetupPartnerPosFlowResponse>(api.post('/pos/partner/load'), { throwData: true });
}
